import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Lädt …
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // "developer" is the highest role and may access every route.
  if (roles && user.role !== "developer" && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
